import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import LineGlassMartiniAltIcon from 'components/Luxkit/Icons/line/LineGlassMartiniAltIcon'
import LineGlobeAltIcon from 'components/Luxkit/Icons/line/LineGlobeAltIcon'
import LineTagIcon from 'components/Luxkit/Icons/line/LineTagIcon'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import LineParcelIcon from 'components/Luxkit/Icons/line/LineParcelIcon'
import LineUsdCircleIcon from 'components/Luxkit/Icons/line/LineUsdCircleIcon'
import LineCommentsAltIcon from 'components/Luxkit/Icons/line/LineCommentsAltIcon'
import LineBedQueenIcon from 'components/Luxkit/Icons/line/LineBedQueenIcon'
import LineStarIcon from 'components/Luxkit/Icons/line/LineStarIcon'
import LineDollarSignAltIcon from 'components/Luxkit/Icons/line/LineDollarSignAltIcon'

const TileContainer = styled(Group)`
  color: ${(props) => props.theme.palette.neutral.default.one};
  width: 70vw;

  ${mediaQueryUp.tablet} {
    width: ${rem(296)};
  }

  ${mediaQueryUp.desktop} {
    width: unset;
  }
`

interface Props {
  values: Array<App.ComponentValuePropositionBlock>;
}

interface IconMap {
  [key: string]: JSX.Element;
}

// all the value proposition related icons found in customer portal
const iconMap: IconMap = {
  'Clock With Dollar Icon': <LineClockDollarIcon size="L"/>,
  'Comments Icon': <LineCommentsAltIcon size="L"/>,
  'Dollar Sign Icon': <LineDollarSignAltIcon size="L" />,
  'Martini Glass Icon': <LineGlassMartiniAltIcon size="L" />,
  'Parcel Icon': <LineParcelIcon size="L" />,
  'Phone Icon': <LinePhoneIcon size="L" />,
  'Price Tag Icon': <LineTagIcon size="L" />,
  'Queen Bed Icon': <LineBedQueenIcon size="L"/>,
  'Start Icon': <LineStarIcon size="L"/>,
  'USD Circle Icon': <LineUsdCircleIcon size="L" />,
  'World Icon': <LineGlobeAltIcon size="L" />,
}

function ValuePropositionItems(props: Props) {
  const { values } = props

  return (
    <CardCarousel pageSize={values.length}>
      {values.map(({ icon, title, subtitle, linkText, linkTo }) => (
        <TileContainer key={title} direction="vertical" gap={12}>
          {iconMap[icon]}
          <Group direction="vertical" gap={12}>
            <Group direction="vertical" gap={4}>
              {title && (
                <BodyText variant="medium" weight="bold">
                  {title}
                </BodyText>
              )}
              <BodyText variant="medium">{subtitle}</BodyText>
            </Group>
            {linkText && linkTo && (
              <TextLink
                href={linkTo}
                size="small"
                weight="bold"
                target="_blank"
              >
                {linkText}
              </TextLink>
            )}
          </Group>
        </TileContainer>
      ))}
    </CardCarousel>
  )
}
export default React.memo(ValuePropositionItems)
